import React, { useCallback, useState } from 'react';
import TrueImpactModal from '../../design-system/components/TrueImpactModal';
import LogModal from './LogModal';
import styled from 'styled-components';
import LogTimeline from './LogTimeline';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { COLORS } from '../../design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { LogTimelineEventProps } from './LogTimelineEvent';
import {
  faExclamationTriangle,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const StyledDiv = styled.div`
  cursor: pointer;
  margin-bottom: ${SPACERS.small};
  background-color: ${COLORS.whiteBase};
  padding: ${SPACERS.medium};
  border-radius: 4px;
  border: 1px solid ${COLORS.greyLight};
  display: flex;
  flex-direction: column;
  gap: ${SPACERS.small};
`;

export interface LogCardProps {
  messageId: string;
  name: string;
  email: string;
  org: string;
  timelineData: LogTimelineEventProps[];
}

const LogCard: React.FC<LogCardProps> = ({
  messageId,
  name,
  email,
  org,
  timelineData,
}) => {
  const [open, setOpen] = useState<LogCardProps | undefined>(undefined);
  const handleClose = useCallback(() => setOpen(undefined), [setOpen]);
  const handleOpen = useCallback(
    () => setOpen({ name, email, org, messageId, timelineData }),
    [name, email, org, messageId, timelineData, setOpen],
  );
  return (
    <>
      <StyledDiv onClick={handleOpen}>
        <div className="text-wrapper">
          <TrueImpactText variant="body-bold" className="nav-item-name">
            {name}
          </TrueImpactText>
          <TrueImpactText variant="body" className="nav-item-name">
            {email}
          </TrueImpactText>
          <TrueImpactText
            variant="body-small"
            color="greyDark"
            className="nav-item-name"
          >
            {org}
          </TrueImpactText>


        </div>
        <LogTimeline timelineEvents={timelineData} />
        {(!timelineData[0].originalEvent.body) && <TrueImpactText><FontAwesomeIcon
          color="red"
          icon={faExclamationTriangle}
        /> No Message Body</TrueImpactText>}

      </StyledDiv>
      {open && (
        <TrueImpactModal
          maxWidth="1300px"
          open={true}
          hideFooter={true}
          onClose={handleClose}
        >
          <LogModal timelineData={open.timelineData} />
        </TrueImpactModal>
      )}
    </>
  );
};

export default LogCard;
